import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Button from '../Button';
export default function WithdrawBlockedAlert({ onVerifyClick, className = '' }) {
    return (React.createElement("div", { className: `rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900 ${className}`.trim(), role: "alert" },
        React.createElement("div", { className: "flex items-start gap-2.5" },
            React.createElement(AlertTriangle, { className: "mt-0.5 h-5 w-5 shrink-0 text-amber-700", "aria-hidden": true }),
            React.createElement("div", { className: "min-w-0 flex-1" },
                React.createElement("div", { className: "font-semibold text-amber-950" }, "Verification required"),
                React.createElement("p", { className: "mt-1 text-xs leading-snug text-amber-900/90" }, "Verify your email or phone before you can withdraw funds."),
                onVerifyClick ? (React.createElement(Button, { type: "button", variant: "outline", size: "sm", className: "mt-2.5", onClick: onVerifyClick }, "Verify account")) : null))));
}
